import { toast } from "sonner";
import { updateJob } from "./api";
import { useMutation } from "@tanstack/react-query";
import { invalidateAllQueries } from "utils/utils";

function buildPayload(values) {
  const payload = {};

  if ("coordinator" in values) {
    payload.coordinator = values.coordinator?.id;
  }

  if ("tags" in values) {
    payload.tags = Array.isArray(values.tags)
      ? values.tags.map((t) => ({ tag: typeof t === "object" ? t?.id : t }))
      : values.tags;
  }
  Object.entries(values).forEach(([key, value]) => {
    if (!["coordinator", "tags"].includes(key)) {
      payload[key] = value;
    }
  });
  return payload;
}

export function useUpdateJob(options = {}) {
  const { onSuccess: customOnSuccess, onError: customOnError } = options;

  return useMutation({
    mutationFn: async ({ id, values }) => {
      const payload = buildPayload(values);
      return updateJob({
        id,
        item: payload,
      });
    },
    onError: (error) => {
      toast.error(error.message);
      customOnError?.(error.message);
    },
    onSuccess: async (data) => {
      invalidateAllQueries();

      toast.success("Job updated successfully");
      customOnSuccess?.(data);
    },
  });
}
